import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { ROUTE_AUTH_LOGIN, ROUTE_DRIVER } from '../util/constants';

interface Props {
  children: JSX.Element;
}

export default function RequiredFleetManager({ children }: Props) {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const location = useLocation();

  // A driver login has its own phone screen, not the dashboard.
  if (currentUser.roles?.includes('fleet_driver') && !currentUser.roles?.includes('fleet_manager')) {
    return <Navigate to={ROUTE_DRIVER} />;
  }
  if (!currentUser.roles?.includes('fleet_manager')) {
    return <Navigate to={ROUTE_AUTH_LOGIN} state={{ from: location }} />;
  }

  return children;
}
